import { AlignType } from 'common/types/styleTypes'
import { useCalculateFontSize } from './use-calculate-font-size'
import { useCalculateLineHeight } from './use-calculate-line-height'
import { useCalculateTextAlign } from './use-calculate-text-align'
import { useCalculateLetterSpacing } from './use-calculate-letter-spacing'
import { useCalculateFontFamily } from './use-calculate-font-family'
import { useCalculateFontStyle } from './use-calculate-font-style'
import { useCalculateFontWeight } from './use-calculate-font-weight'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const useCalculateTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
  typographyType,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
  typographyType?: WebsiteSettingsTypographyTypeEnum
} = {}) => {
  const returnUseCalculateFontFamily = useCalculateFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType,
  })

  const returnUseCalculateFontStyle = useCalculateFontStyle({
    fontStyle,
    mobileFontStyle,
    typographyType,
  })

  const returnUseCalculateFontWeight = useCalculateFontWeight({
    fontWeight,
    mobileFontWeight,
    typographyType,
  })

  const returnUseCalculateFontSize = useCalculateFontSize({
    fontSize,
    mobileFontSize,
    typographyType,
  })

  const returnUseCalculateLineHeight = useCalculateLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType,
  })

  const returnUseCalculateTextAlign = useCalculateTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType,
  })

  const returnUseCalculateLetterSpacing = useCalculateLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType,
  })

  return {
    ...returnUseCalculateFontSize,
    ...returnUseCalculateLineHeight,
    ...returnUseCalculateTextAlign,
    ...returnUseCalculateLetterSpacing,
    ...returnUseCalculateFontFamily,
    ...returnUseCalculateFontWeight,
    ...returnUseCalculateFontStyle,
  }
}
